import { StyledToastContainer } from '@/ui/components/toasting/Toast.styles'
import ToastIcon from '@assets/images/toast-icon.svg?react'
import { useCustomTheme } from '@/core/theme'
import { theme } from '@core/theme/theme-light'
import { convertStrToLinkComponent } from '@core/utils/convertStrToLinkComponent'
import { Slide, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const TOAST_AUTO_CLOSE_DURATION = 5000
export interface CustomToastProps {
    type: 'info' | 'success' | 'warning' | 'error'
    data: string
    withLink?: { link: string; text: string }
    autoCloseDuration?: number
    testId?: string
}

const CustomToastingContainer = () => {
    const theme = useCustomTheme()

    return (
        <StyledToastContainer
            position="top-center"
            transition={Slide}
            autoClose={TOAST_AUTO_CLOSE_DURATION}
            hideProgressBar
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            className="toast-container"
            themeDefault={theme}
        />
    )
}

export { CustomToastingContainer }

export const generateToast = ({
    type,
    data,
    autoCloseDuration = TOAST_AUTO_CLOSE_DURATION,
    testId,
}: CustomToastProps) => {
    toast?.[type](
        <span data-testid={testId}>{convertStrToLinkComponent(data)}</span>,
        {
            icon: <ToastIcon color={theme.colors.toast[type]} />,
            autoClose: autoCloseDuration,
        }
    )
}

export default generateToast
